import config from "../MapConfig";
const API_BASE_URL = config.API_BASE_URL;
class ApiResponse<T> {
  data: T | null = null;
  error: string | null = null;
  loading: boolean = true;
  responseCode: number | null = null;

  async useFetch(
    url: string,
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE" = "GET",
    body: any = null,
    isMultipart: boolean = false
  ): Promise<void> {
    this.loading = true;
  
    const token = localStorage.getItem("token");
    let response;
  
    // IMPORTANTE: no usar headers por defecto
    let headers: HeadersInit = {};
  
    if (token) {
      headers = {
        Authorization: `Bearer ${token}`,
      };
    }
  
    let finalBody = null;
  
    if (body) {
      if (isMultipart) {
        finalBody = body;
        // ❌ NO seteamos Content-Type
      } else {
        finalBody = JSON.stringify(body);
        headers = {
          ...headers,
          "Content-Type": "application/json",
        };
      }
    }
  
    let responseCode = 999;
  
    try {
      response = await fetch(`${API_BASE_URL}${url}`, {
        method,
        headers,
        body: finalBody,
      });
      responseCode = response.status;
    } catch (error: any) {
      this.setResponseCode(responseCode);
      this.setError(error.message);
      return;
    }
  
    const contentType = response.headers.get("content-type");
  
    try {
      if (contentType?.includes("application/json")) {
        const jsonData = await response.json();
        response.ok
          ? this.setData(jsonData as T)
          : this.setError(jsonData);
      } else {
        this.setData(null as T);
      }
  
      this.setResponseCode(responseCode);
    } catch (error) {
      this.setError(
        error instanceof Error ? error.message : "Error inesperado"
      );
      this.setResponseCode(responseCode);
    }
  }
  

  setData(data: T) {
    this.data = data;
    this.loading = false;
  }

  setError(error: any) {
    this.error = error;
    this.loading = false;
  }

  setResponseCode(code: number) {
    this.responseCode = code;
  }
}

export default ApiResponse;
